import { DeepPartial, FormTrucker, RiskTruckerModel } from '@/types';
import { dateYmdToDmy, deepMerge } from '@/utils';
import { onlyNumbers, valueOrEmptyString } from '@/utils/string';
import { getCityModelByAddressModel } from './get-city-model-by-address-model';
import { getEmptyTrucker } from '@/context/reducers';

export const parseResultToFormTrucker = (data: DeepPartial<RiskTruckerModel>): FormTrucker =>
  deepMerge<FormTrucker>(getEmptyTrucker(), {
    cpf: onlyNumbers(valueOrEmptyString(data?.cpf)),
    birthday: dateYmdToDmy(data?.birthday),
    cellPhone: valueOrEmptyString(data?.cellPhone),
    fatherName: valueOrEmptyString(data?.fatherName),
    isDriverPhone: !!data?.isDriverPhone,
    isRegistered: !!data?.isRegistered,
    truckerIsActive: !!data?.truckerIsActive,
    isSelfValid: !!data?.isSelfValid,
    motherName: valueOrEmptyString(data?.motherName),
    name: valueOrEmptyString(data?.name),
    profileId: valueOrEmptyString(data?.profileId),
    personId: valueOrEmptyString(data?.personId),
    riskId: valueOrEmptyString(data?.riskId),
    type: 'Autônomo',
    address: {
      complement: valueOrEmptyString(data?.address?.complement),
      neighborhood: valueOrEmptyString(data?.address?.neighborhood),
      number: valueOrEmptyString(data?.address?.number),
      street: valueOrEmptyString(data?.address?.street),
      zipCode: valueOrEmptyString(data?.address?.zipCode),
      location: getCityModelByAddressModel(data?.address),
    },
    cnh: {
      category: valueOrEmptyString(data?.cnh?.category),
      dateFirstLicense: dateYmdToDmy(data?.cnh?.dateFirstLicense),
      expirationDate: dateYmdToDmy(data?.cnh?.expirationDate),
      registrationNumber: valueOrEmptyString(data?.cnh?.registrationNumber),
      securityNumber: valueOrEmptyString(data?.cnh?.securityNumber),
      stateEmission: valueOrEmptyString(data?.cnh?.stateEmission),
    },
  });
